import { Cls, Emojis } from 'app/constants';
import { setSelectedScene } from 'app/slices/NavigationSlice';
import { UserAuthState } from 'app/slices/UserSlice';
import { store } from 'app/store';
import { AppScene } from 'types';

export type AuthPayload = {
  authMode: string;
  userAuthState: UserAuthState;
};

export const authLoader = async ({ params }: any): Promise<AuthPayload> => {
  const authMode = params.authMode;
  const cPath = window.location.pathname;

  const msg = `${Emojis.eyes} %c authLoader %c authMode %c ${authMode} %c cPath %c ${cPath} %c`;
  console.log(msg, Cls.Loc, '', Cls.Val, '', Cls.Msg, '');

  const userAuthState = store.getState().user.authState;

  if (
    userAuthState === UserAuthState.LoggedOut ||
    userAuthState === UserAuthState.NotLoggedIn ||
    userAuthState === UserAuthState.Init
  ) {
    store.dispatch(setSelectedScene(AppScene.Authentication));
  } else {
    // store.dispatch(setSelectedScene(AppScenes.WeeklyGames));
  }

  return {
    authMode,
    userAuthState,
  };
};
